<template>
  <div class="cart">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="购物车"
      fixed
    />

    <!-- 购物车列表 -->
    <div class="cart-content">
      <!-- 空购物车提示 -->
      <div v-if="cartList.length === 0" class="empty-cart">
        <van-empty 
          description="购物车还是空的" 
          image="cart"
        >
          <van-button round type="danger" class="go-shop" to="/">
            去逛逛
          </van-button>
        </van-empty>
      </div>

      <!-- 购物车商品列表 -->
      <div v-else class="cart-list">
        <van-checkbox-group v-model="checkedGoods">
          <div class="cart-item" v-for="item in cartList" :key="item.id">
            <van-swipe-cell>
              <van-card
                :price="Number(item.price || 0).toFixed(2)"
                :title="item.title"
                :thumb="item.image"
              >
                <!-- 复选框 -->
                <template #tag>
                  <van-checkbox :name="item.id" />
                </template>
                
                <!-- 商品描述 -->
                <template #desc>
                  <span class="goods-desc">{{ item.desc }}</span>
                </template>

                <!-- 商品数量控制 -->
                <template #num>
                  <van-stepper 
                    v-model="item.count" 
                    :min="1"
                    :max="item.stock"
                    @change="updateCount(item)"
                  />
                </template>
              </van-card>
              
              <!-- 滑动删除按钮 -->
              <template #right>
                <van-button 
                  square 
                  text="删除" 
                  type="danger" 
                  class="delete-button"
                  @click="deleteItem(item.id)"
                />
              </template>
            </van-swipe-cell>
          </div>
        </van-checkbox-group>
      </div>
    </div>
	<div style="padding-top: 40px;"><a href="https://beian.miit.gov.cn/">琼ICP备2025057209号-1</a></div>
	
	

    <!-- 底部结算栏 -->
    <van-submit-bar
      :price="totalPrice * 100"
      :button-text="submitBarText"
      :disabled="!checkedGoods.length"
      @submit="onSubmit"
    >
      <van-checkbox v-model="isAllChecked" @change="onCheckAllChange">
        全选
      </van-checkbox>
    </van-submit-bar>
  </div>
</template>

<script>
export default {
  name: 'CartPage',
  data() {
    return {
      defaultCartList: [  // 存储默认商品列表
        {
          id: 2,
          title: '游戏笔记本',
          desc: '16+512GB RTX3060',
          price: 5999.00,
          count: 1,
          stock: 5,
          image: require('@/assets/computer1.png')
        },
        {
          id: 3,
          title: '无线蓝牙耳机',
          desc: '主动降噪 白色',
          price: 899.00,
          count: 1,
          stock: 15,
          image: require('@/assets/phone2.png')
        },
        {
          id: 4,
          title: '高清显示器',
          desc: '27英寸 4K分辨率',
          price: 2499.00,
          count: 1,
          stock: 8,
          image: require('@/assets/computer2.png')
        }
      ],
      cartList: [],  // 实际显示的购物车列表
      checkedGoods: [],
      isAllChecked: false
    }
  },
  mounted() {
    // 从本地存储获取购物车数据
    const savedCartList = localStorage.getItem('cartList')
    if (savedCartList) {
      try {
        const savedItems = JSON.parse(savedCartList)
        if (Array.isArray(savedItems)) {
          // 合并默认商品和保存的商品
          const mergedList = [...this.defaultCartList]
          
          // 添加新商品或更新已存在商品的数量
          savedItems.forEach(savedItem => {
            const existingItem = mergedList.find(item => item.id === savedItem.id)
            if (existingItem) {
              // 如果是默认商品，不更新数量
              if (!this.defaultCartList.find(item => item.id === savedItem.id)) {
                existingItem.count = savedItem.count
              }
            } else {
              // 如果是新商品，添加到列表
              mergedList.push({
                ...savedItem,
                price: Number(savedItem.price || 0)
              })
            }
          })
          
          this.cartList = mergedList
        }
      } catch (error) {
        console.error('解析购物车数据失败:', error)
        this.cartList = [...this.defaultCartList]
      }
    } else {
      // 如果没有保存的数据，使用默认商品列表
      this.cartList = [...this.defaultCartList]
    }
  },
  computed: {
    // 计算总价
    totalPrice() {
      return this.cartList
        .filter(item => this.checkedGoods.includes(item.id))
        .reduce((total, item) => total + (Number(item.price || 0) * item.count), 0)
    },
    // 提交按钮文字
    submitBarText() {
      const count = this.checkedGoods.length
      return count ? `结算(${count})` : '结算'
    }
  },
  watch: {
    // 监听选中商品变化，更新全选状态
    checkedGoods: {
      handler(val) {
        this.isAllChecked = val.length === this.cartList.length && this.cartList.length > 0
      },
      immediate: true
    }
  },
  methods: {
    // 更新商品数量
    updateCount(item) {
      // 确保数量不超过库存
      if (item.count > item.stock) {
        item.count = item.stock
        this.$toast('已达到最大库存数量')
      }
      localStorage.setItem('cartList', JSON.stringify(this.cartList))
    },
    // 删除商品时保留默认商品
    deleteItem(id) {
      // 检查是否是默认商品
      const isDefaultItem = this.defaultCartList.some(item => item.id === id)
      if (isDefaultItem) {
        this.$toast('默认商品不能删除')
        return
      }
      
      this.cartList = this.cartList.filter(item => item.id !== id)
      this.checkedGoods = this.checkedGoods.filter(itemId => itemId !== id)
      localStorage.setItem('cartList', JSON.stringify(this.cartList))
    },
    // 修改全选切换方法
    onCheckAllChange(checked) {
      this.checkedGoods = checked ? this.cartList.map(item => item.id) : []
    },
    // 提交订单
    onSubmit() {
      if (this.checkedGoods.length === 0) {
        this.$toast('请选择要结算的商品')
        return
      }
      const selectedItems = this.cartList.filter(item => 
        this.checkedGoods.includes(item.id)
      )
      console.log('提交订单', selectedItems)
    }
  }
}
</script>

<style scoped>
.cart {
  min-height: 100vh;
  background: #f7f8fa;
  padding-top: 26px;
  padding-bottom: 50px;
}

.cart-content {
  padding: 12px;
}

.empty-cart {
  padding-top: 100px;
}

.go-shop {
  width: 160px;
  margin-top: 20px;
}

.cart-list {
  margin-bottom: 50px;
}

.cart-item {
  margin-bottom: 12px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.goods-desc {
  color: #999;
  font-size: 12px;
}

.delete-button {
  height: 100%;
}

:deep(.van-card) {
  background: #fff;
  padding: 15px;
}

:deep(.van-card__content) {
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

:deep(.van-card__num) {
  position: absolute;
  right: 0;
  bottom: 0;
}

:deep(.van-card__title) {
  text-align: left;
  font-size: 14px;
  margin-bottom: 8px;
}

:deep(.van-card__desc) {
  margin-bottom: 24px;
}

:deep(.van-stepper) {
  margin-top: 8px;
}

:deep(.van-card__price) {
  margin-top: 4px;
}

:deep(.van-checkbox) {
  margin-left: 10px;
}

:deep(.van-submit-bar) {
  bottom: 50px;
  z-index: 99;
}

:deep(.van-submit-bar__text) {
  margin-right: 12px;
}

:deep(.van-card__thumb) {
  width: 90px;
  height: 90px;
}
</style>